/**
 * La entrada al Mapa desde nuestras pantallas, y la pregunta de si se puede ver.
 *
 * Fichero aparte y ligero, deliberadamente: lo importan los resultados y el plan,
 * que ve todo el mundo. Las pantallas del método se cargan solo al entrar en
 * ellas (`App.tsx`), así que quien no las usa no las descarga.
 */

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { base44 } from "../metodo/api/base44Client";

export type Probador = "comprobando" | "si" | "no";

/** ¿Puede esta persona ver el método? Lo decide la API, no el navegador. */
export function useEsProbador(): Probador {
  const [estado, setEstado] = useState<Probador>("comprobando");
  useEffect(() => {
    let vivo = true;
    base44.auth.me().then(
      () => vivo && setEstado("si"),
      () => vivo && setEstado("no"),
    );
    return () => {
      vivo = false;
    };
  }, []);
  return estado;
}


/**
 * La entrada desde nuestras pantallas. Solo se pinta para probadores, así que
 * para el resto de usuarios la aplicación sigue exactamente igual.
 */
export function EntradaAlMapa() {
  const probador = useEsProbador();
  if (probador !== "si") return null;
  return (
    <section className="critero-card flex flex-wrap items-center justify-between gap-4">
      <div className="max-w-prose">
        <p className="critero-label">Siguiente paso · en pruebas</p>
        <p className="mt-2 font-display text-h3 text-ink">Tu diagnóstico, convertido en un Mapa.</p>
        <p className="mt-1 text-caption text-stone">
          Qué trabajar primero, cómo avanzar y cómo cerrar la decisión.
        </p>
      </div>
      <Link to="/acceso" className="critero-boton">
        Abrir mi Mapa
      </Link>
    </section>
  );
}
